<style lang="scss" >
.app-layout {
  &__header {

  }

  &__body {

  }

  &__footer {
    color: white;
    background-color: color(primary);
  }
}
</style>

<template>
  <div class="app-layout w-full h-full flex flex-col">
    <v-browser-notification />
    <header class="app-layout__header w-full">
      <v-header />
    </header>
    <div
      id="app-body"
      class="app-layout__body w-full h-full"
    >
      <slot />
    </div>
    <footer class="app-layout__footer w-full">
      <v-footer />
    </footer>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {LoadsDataMixin} from '@/mixins/LoadsDataMixin';

export default {
  name: 'AppLayout',
  mixins: [
    LoadsDataMixin,
  ],
  computed: {
    ...mapGetters({
      loadingFutures: 'loadingFutures',
      apiData: 'futureData',
    }),
  },
  watch: {
    loadingFutures() {
      this.loading = this.loadingFutures && !this.hasData;
    },
  },
  methods: {
    ...mapActions({
      loadData: 'loadFutures',
    }),
    hasData() {
      return Object.keys(this.apiData).length > 0;
    },
  },
};
</script>
